import React from 'react';
import App from './app/app';
import { createRoot } from 'react-dom/client';
import reportWebVitals from '@monorepo/tools/src/lib/tools/report-web-vitals';
import { initStore } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore, AdminxStore } from './modules/stores';
import './styles/global.scss';

const container: HTMLElement | null = document.getElementById('root');
const root = createRoot(container as Element);
initStore<IAdminxStore>(AdminxStore);

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
